module.exports = __webpack_public_path__ + "static/devops3-ed5806ab4c00d541739629d4fda40d83.svg";